import React from "react";
import { Card, CardBody, CardHeader, CardFooter } from "../card/card.jsx";

const CommentsTable = ({ songReelId, loading, handleGenerateSongFile, handleExtractComments, commentsData, selectedRows, toggleRowSelection, platform }) => {
    const selectedCommentsCharCount =
      commentsData && commentsData.comments
        ? selectedRows.reduce(
            (acc, idx) => acc + (commentsData.comments[idx]?.text?.length || 0),
            0
          )
        : 0;
  
    return (
     <Card>
      <CardHeader className="d-flex justify-content-between align-items-center">
        <h4>Extract & Select Comments</h4>
        {songReelId && <button
          className="btn btn-primary"
          onClick={handleExtractComments}
          disabled={loading}
        >
          {loading
            ? "Extracting..."
            : (commentsData && commentsData.comments
                ? "Extract More Comments"
                : "Extract Comments")}
        </button>}
      </CardHeader>

      <CardBody>
        {commentsData && commentsData.comments ? (
          <div className="mt-2">
            {commentsData.comments.length > 0 ? (
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Comment</th>
                    <th>Created At</th>
                  </tr>
                </thead>
                <tbody>
                  {commentsData.comments.map((comment, index) => (
                    <tr
                      key={index}
                      onClick={() => toggleRowSelection(index)}
                      style={
                        selectedRows.includes(index)
                          ? { border: "2px solid green", cursor: "pointer" }
                          : { cursor: "pointer" }
                      }
                    >
                      <td>{comment.username}</td>
                      <td>{comment.text}</td>
                      <td>{comment.createdAt}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No comments found.</p>
            )}
          </div>
        ) : null}
      </CardBody>
      <CardFooter className="d-flex justify-content-between align-items-center">
        <p>
          <strong>Selected Comments Characters: </strong>
          {selectedCommentsCharCount}
        </p>
        {selectedCommentsCharCount > 500 && <button className="btn btn-info me-2" onClick={handleGenerateSongFile} disabled={loading}>
          {loading ? "Processing..." : "Generate Song File"}
        </button>}
        {selectedCommentsCharCount <= 500 && <button className="btn btn-secondary me-2" disabled>
          Select more comments to generate song file
          </button>}
      </CardFooter>
     </Card>
    );
  };

  export default CommentsTable;